import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Modal from "@material-ui/core/Modal";
import Backdrop from "@material-ui/core/Backdrop";
import Fade from "@material-ui/core/Fade";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import Grid from "@material-ui/core/Grid";
import red from "@material-ui/core/colors/red";
import "./MyComponent2.css";

import useBrowserContextCommunication from "react-window-communication-hook";

const useStyles = makeStyles((theme) => ({
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    //padding: theme.spacing(2, 4, 3),
  },
  grid: {
    height: "0px",
    marginLeft: "96%",
  },
}));

export default function CitappModal(props) {
  const classes = useStyles();
  const [closeModal, setCloseModal] = useState(true);
  const [communicationState, postMessage] = useBrowserContextCommunication(
    "DashboardStaffChanel"
  );

  const handleCloseButton = () => {
    postMessage({
      PriorityStatusChanged: true,
    });
    setCloseModal(true);
    props.handleOpenCloseCitappModal("");
  };

  useEffect(() => {
    return () => {
      postMessage({
        PriorityStatusChanged: true,
      });
    };
  }, []);

  return (
    <Modal
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      className={classes.modal}
      open={props.open}
      onClose={props.handleOpenCloseCitappModal}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 500,
      }}
      disableBackdropClick
      disableEscapeKeyDown
    >
      <Fade in={props.open}>
        <Grid className={classes.paper}>
          <Grid className={classes.grid}>
            <IconButton
              edge="start"
              size="medium"
              onClick={() => handleCloseButton()}
            >
              <CloseIcon style={{ color: red[400] }} />
            </IconButton>
          </Grid>
          <iframe
            className="iframe-container2"
            id="inlineFrameExample"
            title="Inline Frame Example"
            width="100%"
            height="100%"
            border="none"
            src={props.urlCitapp}
          ></iframe>
        </Grid>
      </Fade>
    </Modal>
  );
}
